import { trackSigninFieldChangeKeyboardInput } from "@faire/web-api--source/events/signin/keyboardInput/fieldChange";
import { trackSigninLoginPageSubmit } from "@faire/web-api--source/events/signin/submit/loginPage";
import { trackSigninLoginModalView } from "@faire/web-api--source/events/signin/view/loginModal";
import { useCallback } from "react";
export var useSignInEventTracker = function(currentView) {
    var trackView = useCallback(function() {
        trackSigninLoginModalView(currentView);
    }, [
        currentView
    ]);
    var trackFieldValue = useCallback(function(fieldName, fieldValue) {
        trackSigninFieldChangeKeyboardInput(fieldName, fieldValue, currentView);
    }, [
        currentView
    ]);
    var trackSubmit = useCallback(function() {
        trackSigninLoginPageSubmit(currentView);
    }, [
        currentView
    ]);
    return {
        trackView: trackView,
        trackSubmit: trackSubmit,
        trackFieldValue: trackFieldValue
    };
};
